export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Іздеу"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіз демо-режимдесіз. Қалдықтар мен операциялар оқулық."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жұмыс кабинетіне өту"])}
}